import Button from "components/Common/Button";
import styled from "styled-components";
import { UserAddIcon } from "@heroicons/react/solid";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 0px;
  margin-bottom: 12px;
`;

export const ButtonSection = ({ onOpen }: any) => {
  return (
    <Wrapper>
      <Button
        active
        title={"Add user"}
        onClick={onOpen}
        size={"medium"}
        bgColor={"#0E7EE4"}
        width={160}
        icon={<UserAddIcon style={{ height: "24px", width: "24px" }} color={"white"} />}
      />
    </Wrapper>
  );
};
